import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=6936c6e3&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=ts"
export * from "./setPassword.vue?vue&type=script&lang=ts"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=6936c6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936c6e3",
  null
  
)

export default component.exports